import type { JSX } from '@market/web-components';

export interface Toast {
  isPersistent?: boolean;
  message: string;
  variant?: JSX.MarketToast['variant'];
  href?: string;
  linkText?: string;
}

export const createMarketToastElement = ({
  isPersistent = false,
  message,
  variant = 'info',
  linkText,
  href,
}: Toast) => {
  const toastElement: globalThis.HTMLMarketToastElement =
    document.createElement('market-toast');
  toastElement.persistent = isPersistent;
  toastElement.textContent = message;
  toastElement.variant = variant;

  if (linkText && href) {
    const link = document.createElement('a');
    link.textContent = linkText;
    link.slot = 'action';
    link.href = href;
    toastElement.appendChild(link);
  }
  return toastElement;
};
